import React, { useState } from "react";
import styled from "styled-components";

const Wrap = styled.div`
  margin: 16px 0 32px;
  border: 1px solid var(--nd-border);
  border-radius: 8px;
  background: var(--nd-surface);
`;

const Toggle = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 14px 18px;
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--nd-text-secondary);
  text-align: left;

  &:hover { color: var(--nd-text-display); }
  &:focus { outline: none; color: var(--nd-text-display); }
`;

const Chevron = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 14px;
  color: var(--nd-text-disabled);
  transition: transform 200ms cubic-bezier(0.25, 0.1, 0.25, 1);
  transform: ${({ open }) => (open ? "rotate(90deg)" : "rotate(0deg)")};
`;

const Body = styled.div`
  padding: ${({ open }) => (open ? "0 18px 18px" : "0 18px")};
  max-height: ${({ open }) => (open ? "60vh" : "0")};
  overflow-y: ${({ open }) => (open ? "auto" : "hidden")};
  transition: max-height 250ms cubic-bezier(0.25, 0.1, 0.25, 1), padding 250ms;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  color: var(--nd-text-primary);
  line-height: 1.6;

  & h4 {
    font-family: 'Space Mono', monospace;
    font-size: 10px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--nd-text-disabled);
    margin: 18px 0 8px;
  }

  & p { margin: 0 0 12px; color: var(--nd-text-secondary); }

  & ol, & ul {
    margin: 0 0 12px;
    padding-left: 20px;
    color: var(--nd-text-secondary);
  }

  & li { margin: 4px 0; }

  & code {
    font-family: 'Space Mono', monospace;
    font-size: 12px;
    background: var(--nd-black);
    border: 1px solid var(--nd-border);
    border-radius: 3px;
    padding: 1px 6px;
    color: var(--nd-text-display);
  }

  & a {
    color: var(--nd-text-display) !important;
    border-bottom: 1px solid var(--nd-border-visible);
    text-decoration: none !important;
  }
`;

const Instructions = ({ label = "Instructions", children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Wrap>
      <Toggle
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((p) => !p)}
      >
        <span>{open ? "Hide" : "Show"} {label}</span>
        <Chevron open={open} aria-hidden="true">›</Chevron>
      </Toggle>
      <Body open={open} aria-hidden={!open}>{children}</Body>
    </Wrap>
  );
};

export default Instructions;
